"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Kentaro Kawakatsu
 */
var RenderingObject = /** @class */ (function () {
    function RenderingObject($context) {
        this.context = $context;
        this.vboList = [];
        this.vboDataList = [];
        this.init();
    }
    RenderingObject.prototype.init = function () {
    };
    RenderingObject.prototype.attachShader = function ($shader) {
        this.shader = $shader;
    };
    RenderingObject.prototype.bindVertexbuffer = function () {
        var length = this.shader.attributeList.length;
        for (var i = 0; i < length; i++) {
            var attribute = this.shader.attributeList[i];
            if (attribute.location >= 0) {
                var vbo = this.getVertexBuffer(attribute.name);
                this.context.bindBuffer(this.context.ARRAY_BUFFER, vbo.buffer);
                this.context.enableVertexAttribArray(attribute.location);
                this.context.vertexAttribPointer(attribute.location, attribute.stride, this.context.FLOAT, false, vbo.byteStride, vbo.bufferOffset);
            }
        }
    };
    RenderingObject.prototype.getVertexBuffer = function (attributeName) {
        var length = this.vboList.length;
        for (var i = 0; i < length; i++) {
            var attribute = this.vboList[i];
            if (attribute.name === attributeName) {
                return attribute;
            }
        }
        return null;
    };
    RenderingObject.prototype.bindIndexbuffer = function () {
        this.context.bindBuffer(this.context.ELEMENT_ARRAY_BUFFER, this.ibo);
    };
    return RenderingObject;
}());
exports.RenderingObject = RenderingObject;



//////////////////
// WEBPACK FOOTER
// ./src/ts/myLib/webgl/engine/RenderingObject.ts
// module id = 25
// module chunks = 0